import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'


class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width: 767px) {
                width: 100%;           
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;            
        `
        
        const Content = styled.div`
            position: relative;
            z-index: 10;             
        `

        const Heading2 = styled.h2`
            font-size: 70px;
            font-family: Poppins;
            color: #fff;
            line-height: 80px;
            text-align: center;
            font-weight: bold;
            @media (max-width: 767px) {
                margin-top: 30px;
                font-size: 40px;
                line-height: 40px;
            }            
        `
        
        const { data } = this.props;
        const imageData = getImage(data.background.childImageSharp.gatsbyImageData);
        
        return (
            <Section>
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 250}px` }}>
                    <GatsbyImage
                        image={imageData}
                        alt="VASCO Solutions"
                        style={{ position: 'absolute', width: '110%', height: '100%', opacity: 0.7 }}
                    />
                    <Container>
                        <Row>
                            <Col md={12}>
                                
                                    <Content>
                                        <Heading2>Servidores VPS HDD Powered by KVM con cPanel</Heading2>
                                    </Content>
                                
                            </Col>
                        </Row>
                    </Container>
                </Overlay>
            </Section>
        )
    }
}

const Background = () => (
    <StaticQuery
        query={graphql`
            {
                background: file(relativePath: { eq: "hdd.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 2000)
                    }
                }
            }
        `}
        render={data => <Hero data={data} />}
    />
);

export default Background;
